import { render, staticRenderFns } from "./statisticsHome.vue?vue&type=template&id=3b9dcf04&scoped=true&"
import script from "./statisticsHome.vue?vue&type=script&lang=js&"
export * from "./statisticsHome.vue?vue&type=script&lang=js&"
import style0 from "./statisticsHome.vue?vue&type=style&index=0&id=3b9dcf04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dcf04",
  null
  
)

export default component.exports